import { render, staticRenderFns } from "./classical-validation-score-material.vue?vue&type=template&id=0f18eae0"
import script from "./classical-validation-score-material.vue?vue&type=script&lang=js"
export * from "./classical-validation-score-material.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports